import { useAppContext } from '../../../AppContext';
import { Cell, File, FormItem, List } from '@vkontakte/vkui';
import { Icon24Camera } from '@vkontakte/icons';
import React, { useState } from 'react';
import { Image as VkImage } from '@vkontakte/vkui/dist/components/Image/Image';
import bridge from '@vkontakte/vk-bridge';
import * as Sentry from '@sentry/browser';

export const UploadImageComponent = ({error, setError, value, setValue, label, maxSize, maxSizeError, errorTextType, buttonLabel}) => {
  const context = useAppContext();
  const availableTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  const [fileLoading, setFileLoading] = useState(false);

  const onChange = (file) => {
    if (file === null) {
      setError('');
      return;
    }

    if (availableTypes.indexOf(file.type) === -1) {
      setError(errorTextType);
    } else if (file.size > maxSize) {
      setError(context.lang().replace(maxSizeError, {'size': Math.ceil(context.store.maxFileSize / 1024 / 1024)}));
    } else {
      setError('');
      setFileLoading(true);
      context.httpClient()
        .uploadEventImageV3(file)
        .then((response) => {
          setValue(response.data);
          setFileLoading(false);
        })
        .catch((error) => {
          context.showError(error);
          setFileLoading(false);
        });
    }
  }

  return (<>
    <FormItem
      top={label}
      status={error.length > 0 ? 'error' : ''}
      bottom={error}
    >
      {
        !value && (<File
          onChange={(event) => onChange(event.target.files[0] || null)}
          stretched={true}
          align={'center'}
          before={fileLoading ? <Icon24Camera /> : null}
          mode={fileLoading ? 'primary' : 'outline'}
          size={'l'}
          accept={availableTypes.join(', ')}
          loading={fileLoading}
          disabled={fileLoading}
          multiple={false}
        >
          {
            fileLoading ? '' : buttonLabel
          }
        </File>)
      }
      </FormItem>
      {
        value && (<List>
          <Cell
            key={value.id}
            mode="removable"
            before={
              <VkImage
                mode="app"
                size={42}
                src={value.src_s}
                onClick={() => {
                  bridge.send('VKWebAppShowImages', {
                      images: [value.src],
                      start_index: 0,
                    })
                    .then((data) => {
                      Sentry.captureMessage(JSON.stringify(data));
                    })
                    .catch((error) => {
                      Sentry.captureException(error);
                      console.error(error);
                    });
                }}
              />
            }
            onRemove={() => setValue(null)}
          >
            {value.name}
          </Cell>
        </List>)
      }
  </>);
}
